<template>
    <div>
        <submitTask :task-data="taskData" data-type="translation_task" submit-file @refreshCurrentPage="refreshCurrentPage"/>
        <div class="reTestBtn" v-if="$store.getters.selfInfo.current_state == 'test_refused'">
            <el-button type="primary" @click="reTestEvent">申请重新测试</el-button>
        </div>
    </div>
</template>

<script>
    import submitTask from "../../components/task/submitTask";

    import {changeReTest, getJobList} from "../../api/translator";
    import {whoAreYou} from "../../api/premission";

    export default {
        name: "submit",
        components:{submitTask},
        data(){
            return{
                taskData: [],
                offset: 0,
                limit: 20,
                total: 0
            }
        },
        methods:{
            reTestEvent(){
                changeReTest()
                    .then(res=>{
                        this.$message.success("申请重新测试，稍后我们将为您派发测试文件")
                        whoAreYou()
                            .then(data=>{
                                this.$store.commit("permission/SET_INFO", data)
                            }).catch(error=>{
                            console.log(error)
                        })
                    })
                    .catch(error=>{
                        this.$message.error(error.data.error)
                    })
            },
            refreshCurrentPage(){
                this.offset -= 1;
                this.getJobListEvent(this.offset)
            },
            async getJobListEvent(offset){
                await getJobList(offset, "translate", this.limit, 'accept')
                .then(res=>{
                    this.taskData = res.results;
                    this.offset += 1;
                    this.total = res.total;
                })
            }
        },
        created() {
            this.getJobListEvent(this.offset)
        }
    }
</script>

<style scoped>
    .reTestBtn{
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0;
    }
</style>